// RFC4122 v4 UUID with safe fallbacks (no 'self' or 'globalThis')
export function randomUUID() {
  const cryptoObj =
    (typeof window !== 'undefined' && window.crypto) || undefined;

  // Native support (modern browsers)
  if (cryptoObj && typeof cryptoObj.randomUUID === 'function') {
    return cryptoObj.randomUUID();
  }

  // Cryptographically strong fallback
  if (cryptoObj && typeof cryptoObj.getRandomValues === 'function') {
    const bytes = new Uint8Array(16);
    cryptoObj.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
    bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10
    const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0,8)}-${hex.slice(8,12)}-${hex.slice(12,16)}-${hex.slice(16,20)}-${hex.slice(20)}`;
  }

  // Last-resort (non-crypto) fallback
  let s = '', i = 0;
  while (i++ < 36) {
    if (i === 9 || i === 14 || i === 19 || i === 24) s += '-';
    else if (i === 15) s += '4';
    else {
      const r = (Math.random() * 16) | 0;
      s += (i === 20 ? (r & 0x3) | 0x8 : r).toString(16);
    }
  }
  return s;
}
